import { ToastProps } from '@shopify/polaris';
import { create } from 'zustand';

export type ImageSource = 'upload' | 'signature';

interface State {
    currentImage: File | null;
    imageSource: ImageSource | null;
    toast: Pick<ToastProps, 'content' | 'error' | 'icon' | 'tone'> | null;
    lastSelectedOrderId: string | null;
    lastOrderSearchQuery: string;
}

interface Actions {
    setCurrentImage: (value: State['currentImage'], source?: ImageSource) => void;
    setToast: (value: State['toast']) => void;
    setLastSelectedOrderId: (value: State['lastSelectedOrderId']) => void;
    setLastOrderSearchQuery: (value: State['lastOrderSearchQuery']) => void;
}

type Store = State & Actions;

const useMainStore = create<Store>((set) => ({
    currentImage: null,
    imageSource: null,
    toast: null,
    lastSelectedOrderId: null,
    lastOrderSearchQuery: '',
    setCurrentImage: (currentImage, source) =>
        set({
            currentImage,
            imageSource: source || null,
        }),
    setToast: (toast) => set({ toast }),
    setLastSelectedOrderId: (lastSelectedOrderId) => set({ lastSelectedOrderId }),
    setLastOrderSearchQuery: (lastOrderSearchQuery) => set({ lastOrderSearchQuery }),
}));

export default useMainStore;
